import { Switch } from "@mui/material";
import { SettingsItemLabel } from "./UserSettings.style";
import { useTranslation } from "hhn-commons";
import { useContext } from "react";
import { NotificationContext } from "../../context/NotificationContext";

export const MuteNotifications = () => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "settings" });

  const { toggleMute, isMuted } = useContext(NotificationContext);

  return (
    <>
      <Switch
        slotProps={{
          input: {
            "aria-label": "Desktop Notifications",
          },
        }}
        checked={isMuted}
        onChange={toggleMute}
      />
      <SettingsItemLabel>
        {tNs("notifications.muteNotifications")}
      </SettingsItemLabel>
    </>
  );
};
